import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination } from "swiper";
//Import Swiper styles
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import { Icon, IconType } from "../icon/Icon";
SwiperCore.use([Navigation, Pagination]);

export interface NotificationInputData { 
    icon: IconType; 
    message: string; 
    suffixmessage?: string | undefined; 
}

function AlertNotification(props: {
    justifyContent?: string | undefined,
    items: Array<NotificationInputData>, 
    color: string, 
    isCloseable: boolean,
    onCloseAlert?: () => void}) {

    const [alertItems, setAlertItems] = useState<Array<NotificationInputData>>([]);
    
    const onCloseAlertItem = () => {
        props.onCloseAlert!();
    };
  
    

    useEffect(() => {
        setAlertItems([]);
        if(props.items?.length > 0){
            // setTimeout(() => {
                setAlertItems(props.items);
            // },10);
        }
    }, [props.items]);
  
    return ( <div className="w-100">
        {alertItems && alertItems.length > 0 &&
            <div className={'neu-bg-' + props.color + ' alerts-notification-container'}>
                <div className="alert-wrap">
                    {alertItems.length > 1 ?
                        <Swiper navigation
                            spaceBetween={0}
                            slidesPerView={1}
                            breakpoints={{
                            "320": { slidesPerView: 1 },
                            "800": { slidesPerView: 1 },
                            "1200": { slidesPerView: 1 }
                            }}>
                            { alertItems.map((alert: NotificationInputData, alertIndex: number) => (
                                <SwiperSlide key={alertIndex}>
                                    <div key={alertIndex} className={`alert-item d-flex align-items-center${props.justifyContent ? ' ' + props.justifyContent: ' justify-content-between'}`}>
                                        <div className="alert-item-child d-flex align-items-center">
                                            <Icon className="alert-icon" value={alert.icon}></Icon>
                                            <div className="alert-message text-medium">{alert.message}</div>
                                        </div>
                                        <div className="alert-item-child d-flex align-items-center">
                                            <div className="alert-suffix-message text-medium">{alert.suffixmessage}</div>
                                        </div>
                                    </div>
                                </SwiperSlide>))
                            }
                        </Swiper> : 
                        alertItems.map((alert: NotificationInputData, alertIndex: number) => (
                            <div key={alertIndex} className="swiper-slide">
                                <div key={alertIndex} className={`alert-item d-flex align-items-center${props.justifyContent ? ' ' + props.justifyContent: ' justify-content-between'}`}>
                                    <div className="alert-item-child d-flex align-items-center">
                                        <Icon value={alert.icon} className="alert-icon"></Icon>
                                        <div className="alert-message text-medium">{alert.message}</div>
                                    </div>
                                    <div className="alert-item-child d-flex align-items-center">
                                        <div className="alert-suffix-message text-medium">{alert.suffixmessage}</div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }  
                    { props.isCloseable && <div onClick={onCloseAlertItem} className="alert-close"><Icon value="close"></Icon></div>}
                </div>
            </div>
        }
        </div>
    );
  
}
export default AlertNotification;